<template>
  <div id="modalBom" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      :class="{ 'modal-max': max }"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("rm.BOM结构图") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          class="modal-body pd-25"
          :style="{ maxHeight: max ? maxH + 'px' : '460px' }"
        >
          <el-tree
            ref="treeBoom"
            node-key="sku"
            :expand-on-click-node="false"
            :data="items"
            :props="defaultProps"
            :default-expand-all="true"
          >
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>{{ $t("rm.产品名：") }}</span>
              <span>{{ data.name }}</span>
              <span>&nbsp;&nbsp;SKU：</span>
              <span>{{ data.sku }}</span>
              <template v-if="data.needNum">
                <span>&nbsp;&nbsp;{{ $t("order.数量：") }}</span>
                <span>{{ data.needNum }}</span>
                <span v-if="data.unitName">&nbsp;{{ data.unitName }}</span>
              </template>
              <template v-if="data.purchaseDuration">
                <span>&nbsp;&nbsp;{{ $t("rm.耗时：") }}</span>
                <span>{{ data.purchaseDuration }}</span>
              </template>
              <template v-if="data.price">
                <span>&nbsp;&nbsp;{{ $t("rm.成本：") }}</span>
                <span>{{ data.price }}</span>
              </template>
              <template v-if="data.skuType">
                <span>&nbsp;&nbsp;{{ $t("rm.原料属性：") }}</span>
                <span>{{ skuTypes[data.skuType] }}</span>
              </template>
            </span>
          </el-tree>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("order.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      max: true,
      maxH: 460,
      defaultProps: {
        children: "children",
        label: "label",
      },
      skuTypes: {
        1: this.$t("rm.成品sku"),
        5: this.$t("rm.原料sku"),
        7: this.$t("rm.半成品sku"),
      },
    };
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    $("#modalBom").on("shown.bs.modal", function () {
      $("#modalBom .modal-body").scrollTop(0);
    });
  },
  mounted() {
    $("#modalBom").on("shown.bs.modal", () => {
      this.sizeHeight();
      $(window).on("resize", () => {
        this.sizeHeight();
      });
    });
    $("#modalBom").on("hide.bs.modal", () => {
      $(window).off("resize");
    });
  },
  methods: {
    sizeHeight() {
      let wH = $(window).height(),
        hH = $("#modalBom .modal-header").height(),
        fH = $("#modalBom .modal-footer").height();
      this.maxH = wH - hH - fH - 160;
    },
  },
};
</script>